const Title = () => {
  return (
    <div className="flex w-full items-end justify-center">
      <div className="flex w-[1153px] flex-col items-center">
        <h1 className="text-center font-bold sm:text-6xl">Built for privacy focused teams. </h1>
        <h2 className="bg-linear-to-r from-purple-100 to-blue-400 bg-clip-text text-center font-extrabold text-transparent text-xl sm:text-3xl">
          KEY FEATURES &nbsp;
        </h2>
      </div>
    </div>
  );
};

export default Title;
